<template>
  <div
    :class="[$style.box,{
      [$style.title]:type==='title',
      [$style.image]:type==='image'

    }]"
  >
    <img
      v-if="type==='image'"
      :src="data.url"
    >
    <!-- text inline group -->
    <span
      v-for="(item,index) in text"
      :key="index"
      :class="[$style.text,{
        [$style.url]:item.url,
        [$style.image]:type==='image'

      }]"
    >
      <template v-if="!item.url">

        {{ item.text }}
      </template>
      <a
        :href="item.url"
        v-else
      >
        {{ item.text }}
      </a>
    </span>
    <!-- text inline group -->
  </div>
</template>

<script>

export default {
  name: 'Chunk',
  props: { data: { type: Object, default: () => { return { } } } },
  computed: {
    text () {
      let res = this.data.text
      res = typeof res === 'string' ? [{ text: res }] : res
      return res
    },
    type () {
      let res = this.data.type
      return res || 'default'
    }
  }
}
</script>

<style module>
.box{
  position: relative;

  font-size: 19px;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding: 10px 0;
}

.box.title{
  font-size: 40px;
  font-weight: bold;
  margin-top: 36px;
  margin-bottom: 24px;

}

.box.image{
  margin-top: 48px;
  max-width: 1200px;
  display: flex;
  flex-direction: column;

}

.text {
  line-height: 1.7;
}
.text.url{
  /* color: rgb(143, 143, 143); */
}
.text.url,a:visited{
  color: rgb(119, 119, 119);
}

.text.image{
  font-size: 12px;
  color: rgb(124, 129, 129);
  text-align: center;
  margin-top: 15px;
}

</style>
